<script>
	import Error403 from '../components/Error403.svelte';
    import { onMount } from 'svelte';
    import AuthService from '../services/auth.service';
    import ReportsService from '../services/reports.service';
    import OrganizationsService from '../services/organizations.service';
    import Loader from '../components/Loader.svelte';
    import TalentTrackingService from '../services/talentTracking.service';

    let loading = false, permissions = [], organizations = [], selectedOrganization = null,
        tab = 'permissions', allowedEmails = '', errorMessage = '';
    let message = {
        show: false,
        type: '',
        text: ''
    }

    onMount(async () => {
        organizations = await OrganizationsService.list();
        selectedOrganization = organizations[0];
        if (AuthService.canShow('talent_tracking')) {
            getAllowedEmails();
            getUsers();
        }
    });

    async function getUsers() {
        permissions = [];

        if (selectedOrganization){
            var result = null;
            loading = true;
            try {
                result = await ReportsService.getUsersPermissions(selectedOrganization.id);
                if (result && result.data && Array.isArray(result.data)) {
                    permissions = result.data.filter((permission) => {
                        return permission.section === 'TALENT_TRACKING' && permission.user && permission.user.name && permission.user.active === 1;
                    });
                }
            } catch (e) {
                console.log('Error', e);
            } finally{
                loading = false;
            }
        }
    }

    async function changePermission(organization_id, user_id, section, value){
        try {
            await ReportsService.updatePermission(organization_id, user_id, section, value);
        } catch (e) {
            console.log('Error', e);
        }
    }

    function change(organization) {
        selectedOrganization = organization;
        getUsers();
    }

    const resetMessage = function(){
        message = {
            show: false,
            text: '',
            type: ''
        }
    }

    const updateAllowedxEmails = async function() {
        loading = true;
        try {
            const response = await TalentTrackingService.updateAllowedEmails({ emails: allowedEmails });

            if (response && response.data.ok) {
                message = {
                    show: true,
                    text: 'Email accounts updated',
                    type: 'success'
                }
            }else{
                message = {
                    show: true,
                    text: 'Error: ' + response.data.error,
                    type: 'danger'
                }
            }
        } catch (e) {
            message = {
                show: true,
                text: 'Error: ' + e.message,
                type: 'danger'
            }
        } finally {
            loading = false;
        }
    }

    async function getAllowedEmails() {
        loading = true;
        try {
            const response = await TalentTrackingService.getAllowedEmails();

            if (response && response) allowedEmails = response;
        } catch (e) {
            errorMessage = e.message;
        } finally {
            loading = false;
        }
    }

</script>
<main class="pt-3 container">
    <div class="row">
        <div class="col">
            {#if !AuthService.canShow('talent_tracking') }
                <Error403></Error403>
            {:else}
                {#if loading}
                    <Loader></Loader>
                {:else}
                    <ul class="nav nav-pills nav-fill mb-3">
                        <li class="nav-item">
                            <button class="general-tabs btn-block btn-default  {(tab === 'permissions')?'active':''}" on:click={ () => tab = 'permissions'}>Permissions</button>
                        </li>
                        <li class="nav-item">
                            <button class="general-tabs btn-block btn-default  {(tab === 'allowed_emails')?'active':''}" on:click={ () => tab = 'allowed_emails'}>Talent Tracking</button>
                        </li>
                    </ul>
                    {#if message.show}
                        <div class="alert alert-{message.type} mt-3" id="message" role="alert">
                            {message.text}
                            <span class="float-right pointer" on:click={ resetMessage }>x</span>
                        </div>
                    {/if}
                    <div class="row">
                        <div class="col">
                            <p>
                                <a class="navbar-brand" href="/dashboard"><small><i class="fa fa-angle-left"></i> Back to the Dashboard</small></a>
                            </p>
                        </div>
                    </div>
                    {#if tab === 'permissions'}
                        <div class="row">
                            <div class="col-3 mb-2">
                                <h4>Talent Tracking</h4>
                                {#if organizations.length > 0}
                                    <div class="dropdown mb-2 btn-block">
                                        <button class="btn btn-primary btn-block dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {selectedOrganization.name}
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" id="permissions-org-list">
                                            {#each organizations as organization}
                                                <label class="dropdown-item" on:click={ () => change(organization) }>
                                                    {organization.name}
                                                </label>
                                            {/each}
                                        </div>
                                    </div>
                                {/if}
                            </div>
                        </div>
                        <div class="row" id="hr-permissions-div">
                            <div class="col-md-12">
                                <table class="table mb-2">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th class="text-center">Allow</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {#if permissions.length === 0}
                                        <tr>
                                            <td colspan="3">
                                                No users where found in this organization.
                                            </td>
                                        </tr>
                                    {/if}
                                    {#each permissions as permission}
                                        <tr>
                                            <td>{permission.user.name}</td>
                                            <td>{permission.user.email}</td>
                                            <td class="text-center">
                                                <input type="checkbox" checked={permission.level > 0} on:change={ (e) => changePermission(permission.organization_id, permission.user_id, 'talent_tracking', permission.level > 0? 0: 1)}>
                                            </td>
                                        </tr>
                                    {/each}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    {:else if tab === 'allowed_emails'}
                        <div class="row">
                            <div class="col-md-12">
                                <h4>Talent Tracking</h4>
                                <label>Users Allowed:</label>
                                <textarea id="emails-textarea" type="text" bind:value={allowedEmails} placeholder="example1@mail.com, example2@mail.com ..." class="form-control"></textarea>
                                    <p><small>Input email accounts separated by a comma</small></p>
                                <button class="btn btn-success mt-2" on:click={ updateAllowedxEmails }>Update</button>
                            </div>
                        </div>
                    {/if}
                {/if}
            {/if}
        </div>
    </div>

    <style>
        #autocomplete > ul > li:hover{
            z-index: 2;
            color: #fff;
            background-color: #007bff;
            border-color: #007bff;
        }
        #permissions-org-list{
            position: absolute !important;
            transform: translate3d(0px, 36px, 0px) !important;
            top: 0px !important;
            left: 0px !important;
            width: 100% !important;
            will-change: transform !important;
            overflow-y: scroll !important;
            height: 300px !important;
        }
    </style>
</main>
